import * as React from 'react';

function SvgEthChangeArrowDown(props) {
  return (
    <svg
      width={72.438}
      height={50}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 25L72.439 0 56.855 25l15.582 25z" fill={props.color} />
    </svg>
  );
}

export default SvgEthChangeArrowDown;
